import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  IoHomeOutline,
  IoBookOutline,
  IoAddCircle,
  IoNotificationsOutline,
  IoPersonOutline,
} from "react-icons/io5";
import "./BottomNav.css";

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem("auth_token");
  const isLoggedIn = !!token;
  const isMobile = window.innerWidth < 768;

  const hideOnRoutes = [
    "/login",
    "/signup",
    "/forgot-password",
    "/reset-password",
    "/register-confirmation",
    "/privacy",
    "/terms",
    "/about",
    "/help",
    "/careers",
    "/advertise",
    "/welcome",
  ];

  const hideBottomNav =
    !isMobile || !isLoggedIn || hideOnRoutes.includes(location.pathname);

  if (hideBottomNav) return null;

  return (
    <nav className="bottom-nav">
      <NavLink
        to="/"
        className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
      >
        <IoHomeOutline size={22} />
        <span>Home</span>
      </NavLink>

      <NavLink
        to="/my-recipes"
        className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
      >
        <IoBookOutline size={22} />
        <span>My Recipes</span>
      </NavLink>

      <button
        className="nav-item create-btn"
        onClick={() => navigate("/create")}
      >
        <IoAddCircle size={28} color="#00b0ff" />
        <span>Create</span>
      </button>

      <NavLink
        to="/notifications"
        className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
      >
        <IoNotificationsOutline size={22} />
        <span>Notifications</span>
      </NavLink>

      <NavLink
        to="/profile"
        className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
      >
        <IoPersonOutline size={22} />
        <span>Profile</span>
      </NavLink>
    </nav>
  );
}